import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { ProgramContactsTab } from '../tabs/ProgramContactsTab';
export function ContactsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(ProgramContactsTab, {
            programId: programId
        })
    });
}
